import React from 'react';
import BrowserLink from '../../../../../components/BrowserLink';

export function Description({ row }) {
  const quizz = row;

  return (
    <BrowserLink href={quizz.url}>
      {quizz.lock_status && (
        <img className="lock" src={`https://poker-coaching.s3.amazonaws.com/images/pcp/${quizz.lock_status}.png`}
             alt=""/>
      )}
      {quizz.description}
    </BrowserLink>
  );
}
